import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import Mapimage from "../images/map-bg.png";
import HexagonPattern from "../images/hexagon-pattern.png";
import styled from "styled-components";

const Banner = styled.div`
  padding: 0 4rem;
  margin-top: 115px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 550px;
  background: ${(props) => (props.color === "gray" ? "#F1F2F499" : "#F7CB57")};
  background-image: url(${Mapimage});
  background-position: center;
  background-size: cover;
  
  @media (min-width: 768px) and (max-width: 819px) {
    padding: 0rem 3rem;
  }

  @media (max-width: 767px) {
    padding: 0 1rem;
    margin-top: 130px;
  }
`;

const HexagonPatternBg = styled.img`
  width: 180px;
  height: "100%";
  background: transparent;
  object-fit: contain;

  @media screen and (max-width: 480px) {
    width: 110px;
  }
`;

const BannerText = styled.h2`
  display: block;
  color: #121820;
  font-size: 42px;
  font-weight: 600;
  font-family: "Syne";

  @media (max-width: 768px) {
    font-size: 18px;
    font-weight: 700;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (max-width: 768px) {
    gap: 7.5px;
  }
`;

const MainSection = ({
  toggle,
  bannerTxt = "",
  color = "",
  nonNavigablePaths = [],
}) => {
  return (
    <Banner color={color}>
      <RightContainer>
        <Breadcrumbs nonNavigablePaths={nonNavigablePaths} />
        <BannerText>{bannerTxt}</BannerText>
      </RightContainer>
      <HexagonPatternBg src={HexagonPattern} alt="Hexagon Pattern" />
    </Banner>
  );
};

export default MainSection;
